import useNativeLazyLoading from '@charlietango/use-native-lazy-loading';
import React, { ImgHTMLAttributes } from 'react';
import { useInView } from 'react-intersection-observer';

import Image from '../Image';

type LazyImageProps = {
  src: string;
  alt: string;
  options: Record<string, unknown>;
  containerClass?: string;
  forceInView?: boolean;
  inViewOptions?: any;
  animate?: boolean;
  className?: string;
  width?: number;
  height?: number;
} & ImgHTMLAttributes<HTMLImageElement>;

const INVIEW_OPTIONS = { triggerOnce: true, rootMargin: '150px 0px' };

function LazyImage({
  src,
  alt,
  options,
  containerClass,
  forceInView,
  inViewOptions,
  ...rest
}: LazyImageProps) {
  const supportsLazyLoading = useNativeLazyLoading();
  const [ref, inView] = useInView({ ...INVIEW_OPTIONS, ...inViewOptions });
  const showImage = inView || (!forceInView && supportsLazyLoading);

  return (
    <div
      ref={!supportsLazyLoading || forceInView ? ref : undefined}
      className={containerClass}
    >
      {showImage ? (
        <Image {...rest} src={src} options={options} loading="lazy" />
      ) : (
        <noscript>
          <Image src={src} alt={alt} options={options} />
        </noscript>
      )}
    </div>
  );
}

export default LazyImage;
